import { quickProperty, designToken } from '../component-tokens';
import { borderBase } from './common';
export const popoverTokens = {
    name: 'popover',
    reactImports: 'Popover',
    attributes: Object.assign(Object.assign({}, borderBase), { 'box-sizing': quickProperty('border-box'), 'border-radius': quickProperty('4px'), 'background-color': designToken('ui-01'), 'border-color': designToken('ui-02'), 'box-shadow': designToken('elevation-300'), padding: designToken('spacing-04'), color: designToken('text-01') }),
    children: [
        {
            name: 'visible',
            attributes: {
                opacity: quickProperty('1'),
                visibility: quickProperty('visible'),
            },
        },
        {
            name: 'before-after',
            attributes: Object.assign(Object.assign({}, borderBase), { display: quickProperty('none'), position: quickProperty('absolute'), content: quickProperty(''), 'border-color': quickProperty('transparent'), 'pointer-events': quickProperty('none') }),
        },
    ],
    variants: [
        {
            name: 'large',
            attributes: {
                padding: quickProperty('24px'),
            },
        },
        {
            name: 'menu',
            attributes: {
                padding: designToken('spacing-00'),
            },
        },
        {
            name: 'compact',
            attributes: {
                padding: designToken('spacing-02'),
            },
        },
        {
            name: 'inverted',
            attributes: {
                'background-color': designToken('neutral'),
                'border-color': designToken('neutral'),
                color: designToken('text-04'),
                font: designToken('caption-default-01'),
            },
        },
    ],
};
